import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { InsightsService } from '../../services/insights-service';

@Injectable({
  providedIn: 'root',
})
export class AltiusLifeDomainGuard  {
  constructor(private router: Router, private insightsService: InsightsService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.insightsService.isInsightsDomain()) {
      this.router.navigate(['']).then();
      return false;
    }
    return true;
  }
}
